import { FillPage } from '@/components/layout/PageContainer';

export function AclDenied({ operation }: { operation: string }) {
  return (
    <FillPage>
      <div className="my-12 text-center text-base">
        No {operation} permission found in assigned ACL
      </div>
    </FillPage>
  );
}
